import { ReactNode } from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { MapEmbed } from "../../components/contact/map-embed";

type ActionTileProps = {
  icon: ReactNode;
  label: string;
  onClick: () => void;
};

function ActionTile({ icon, label, onClick }: ActionTileProps) {
  return (
    <Card
      onClick={onClick}
      sx={{
        flex: 1,
        p: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
        backgroundColor: "primary.main",
        color: "primary.contrastText",
      }}
    >
      {icon}
      <Typography variant="h5">{label}</Typography>
    </Card>
  );
}

export function ContactPage() {
  return (
    <Box sx={{ px: { xs: 3, md: 8 }, pt: { xs: 4, md: 6 }, pb: { xs: 4, md: 8 } }}>
      <Typography variant="h2" align="center" gutterBottom>
        Contactez-nous!
      </Typography>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} maxWidth={700} mx="auto" mb={4}>
        <ActionTile
          icon={<PhoneIcon fontSize="large" />}
          label="514-668-0275"
          onClick={() => window.open("tel:5146680275")}
        />
        <ActionTile
          icon={<EmailIcon fontSize="large" />}
          label="sseguin007@live.ca"
          onClick={() => {
            window.location.href = "mailto:sseguin007@live.ca";
          }}
        />
      </Stack>

      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        maxWidth={600}
        mx="auto"
        mb={4}
      >
        1077 Chemin de Chambly à Longueuil, près du Cégep Édouard-Montpetit.
        N'hésitez pas à venir faire un tour!
      </Typography>

      <Box display="flex" justifyContent="center">
        <MapEmbed maxWidth={700} />
      </Box>
    </Box>
  );
}
